/**
 * Chatbot Constants
 * Constants used in the chatbot module
 */

import { MessageCircle, Sparkles, TrendingUp } from 'lucide-react';
import type { SuggestedQuery } from './types';

export const DEFAULT_SUGGESTED_QUERIES: SuggestedQuery[] = [
  {
    id: '1',
    text: 'Hi, Do you accept returns?',
    icon: ''
  },
  {
    id: '2',
    text: 'My product is broken, can I return it?',
    icon: ''
  },
  {
    id: '3',
    text: 'It has been more than 15 days, can i return my product?',
    icon: ''
  },
  {
    id: '4',
    text: 'Hi, Do you accept returns?',
    icon: ''
  }
];

export const ONBOARDING_STEPS = [
  {
    id: '1',
    title: 'Ask a question in natural language',
    icon: MessageCircle
  },
  {
    id: '2',
    title: 'Kim AI answers your question based on the knowledge base',
    icon: Sparkles
  },
  {
    id: '3',
    title: 'Improve the answer in case it needs enhancements',
    icon: TrendingUp
  }
];
